<template>
	<div class="verifier-view">
		<SearchEngine />
	</div>
</template>

<script>
import SearchEngine from '@/components/verifier/SearchEngine'

export default {
	name: 'VerifierView',

	components: {
		SearchEngine,
	},
}
</script>

<style lang="stylus" scoped>
.verifier-view 
	display flex
	flex-direction column
	min-height 100vh
	max-height 100vh
	overflow-y scroll

</style>



// WEBPACK FOOTER //
// src/views/VerifierView.vue